import { createSlice } from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { IInitialState } from "./Types";

export const initialState: IInitialState = {
  extractList: [],
  viewExtractList: [],
  extractData: null,
  selectedExtract: null,
  showReports: false,
  searchInput: "",
  viewExtract: null,
  showExtractDetails: false,
  selectedExtractGuid: "",
  dashBoardName: "",
  clickedExtractId: {
    id: "",
    year: ""
  }
};

export const Slice = createSlice({
  initialState,
  name: "extract-list-reducer",
  reducers: Reducer,
});
